import React, { useState } from "react";
import MaintenanceSidebar from "./MaintenanceSidebar";
import { Menu } from "lucide-react";
import "./maintenance-layout.scss";

interface MaintenanceLayoutProps {
  children: React.ReactNode;
  title?: string;
}

/**
 * The maintenance shell.
 *
 * Layout lives in maintenance-layout.scss, not in style props. It used to be
 * inline, and that made the console unusable on a phone in a way no stylesheet
 * could fix: an inline style beats a media query, so `marginLeft: 220` held at
 * every width (leaving 122px of content on a 390px screen, beside 220px of
 * empty space) and the menu button's inline `display: none` could never be
 * undone. The off-canvas sidebar underneath has always worked -- there was
 * simply no way to open it.
 */
const MaintenanceLayout: React.FC<MaintenanceLayoutProps> = ({ children, title }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="maint-shell">
      <MaintenanceSidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && (
        <div className="maint-scrim" onClick={() => setIsSidebarOpen(false)} />
      )}
      <div className="maint-content">
        <header className="maint-topbar">
          <button
            type="button"
            onClick={() => setIsSidebarOpen((prev) => !prev)}
            className="maint-menu-btn"
            aria-label={isSidebarOpen ? "Close menu" : "Open menu"}
            aria-expanded={isSidebarOpen}
          >
            <Menu size={24} />
          </button>
          <h1>Maintenance Console</h1>
        </header>
        <main className="maint-main">
          {title && <h2 className="maint-title">{title}</h2>}
          {children}
        </main>
      </div>
    </div>
  );
};

export default MaintenanceLayout;
